import React from 'react';

const PaymentIcon = (props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='1em'
      height='1em'
      viewBox='0 0 11.473 21'
      {...props}
    >
      <path
        className='subheader__container__dropdowns-icon'
        d='M.75 14.502c.591.232 1.156.486 1.741.676a7.277 7.277 0 003.351.337 2.468 2.468 0 001.094-.423 1.377 1.377 0 00.283-2.011 3.143 3.143 0 00-1.353-.92c-.773-.312-1.561-.586-2.333-.9a6.8 6.8 0 01-2.156-1.333 3.9 3.9 0 01-1.134-3.89A4.414 4.414 0 013.16 2.816c.418-.169.862-.274 1.322-.418v-2.4h2.52v2.251a9.437 9.437 0 013.766.857l-.764 2.88c-.425-.169-.825-.351-1.24-.487a6.812 6.812 0 00-3.239-.319 2.372 2.372 0 00-.885.341 1.158 1.158 0 00-.116 1.932 6.656 6.656 0 001.383.8c.9.4 1.828.723 2.722 1.129a4.979 4.979 0 012.176 1.769 4.654 4.654 0 01-.872 5.865 5.964 5.964 0 01-2.83 1.3c-.163.031-.2.092-.2.247.007.723 0 1.447 0 2.17v.262H4.361v-2.37c-.782-.133-1.534-.214-2.258-.4-.674-.172-1.318-.457-1.977-.69a.155.155 0 01-.116-.218c.241-.922.476-1.846.714-2.769a.17.17 0 01.026-.046z'
        fill='#fff'
      />
    </svg>
  );
};

export default PaymentIcon;
